/**
 * REQ-0040：专项费用申请提交时的企微审批路由提示（纯函数，供 billPaymentDialog 提交前二次确认用）。
 * 口径与后端 act-service ApprovalUtils.sendWechatApproval 对齐：
 *   paymentType='1' 且 非卡航 且 amount <= 50000 → 「费用报销申请」；
 *   paymentType='1' 其余（amount > 50000 或卡航）→ 「专项费用申请」（后端模板 ACT_BILL_PAYMENT_SPECIAL）。
 * 卡航判定与后端 isKhCompany 同口径：officeCode trim 后精确比较 'KH'（大小写敏感），
 * 解析失败按非卡航 fail-open。文案在语言包（zh_CN/en_US 的 Payment.js，其余语种走回退），这里只返回 i18n key。
 */
export const SPECIAL_FEE_AMOUNT_LIMIT = 50000

export const SPECIAL_FEE_ROUTE_TIP_KEYS = {
  expense: 'Payment.specialFeeExpenseApprovalRouteTip',
  special: 'Payment.specialFeeSpecialApprovalRouteTip',
  specialKh: 'Payment.specialFeeSpecialApprovalRouteTipKh'
}

const KH_COMPANY_CODE = 'KH'

export function resolveSpecialFeeApprovalRoute({ paymentType, amount, officeCode }) {
  if (String(paymentType) !== '1') {
    return null
  }
  const kh = officeCode != null && String(officeCode).trim() === KH_COMPANY_CODE
  if (kh) {
    return { isExpenseRoute: false, tipKey: SPECIAL_FEE_ROUTE_TIP_KEYS.specialKh }
  }
  const isExpenseRoute = Number(amount || 0) <= SPECIAL_FEE_AMOUNT_LIMIT
  return {
    isExpenseRoute,
    tipKey: isExpenseRoute ? SPECIAL_FEE_ROUTE_TIP_KEYS.expense : SPECIAL_FEE_ROUTE_TIP_KEYS.special
  }
}
